export default "__VITE_ASSET__DMJ$ySgb__"